import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import {AfoListObservable, AfoObjectObservable, AngularFireOfflineDatabase } from 'angularfire2-offline/database';

// NEED TO CREATE A QUERY FOR GETTING ONE RECORD

@Injectable()
 
export class WildlifeService {
    
    // wildlife: any;
    wildlifeList: AfoListObservable<any>;
    wildlifeListToEdit: FirebaseListObservable<any>;
    wildlifeListArray: any;
    wildlifeListArraySA: any;
    wildlifeListArrayReserve: any;

    species:  AfoObjectObservable<any>;

    taxonomy:      string;
    taxonomylevel: string;
    binomial: string;
   
    //loading: boolean = false;
            
 constructor(public http: Http, public afoDbase: AngularFireOfflineDatabase, public afDbase: AngularFireDatabase) { 
             }
    
  //A: GET DATA FROM FIREBASE
  fetchWildlife(taxonomy,taxonomylevel) {  
    this.wildlifeList = this.afoDbase.list('/wildlife', {
      query: {
      orderByChild: taxonomy,
      equalTo: taxonomylevel 
      }
    });

    //By subscribing we can create arrays for filtering and watch for changes
      this.wildlifeList.subscribe(subscribedWildlife => {
      console.log("change made");
      //console.log("Setting all wildlife to new array");  
      this.wildlifeListArraySA = JSON.parse(JSON.stringify(subscribedWildlife));         
     
      // Sort the data as it gets messed up
      this.wildlifeListArraySA = this.wildlifeListArraySA.sort(function(a, b) {
      return a.label_en.localeCompare(b.label_en);
    });
         
       //console.log("Setting reserveWildlife to new array for all Amakhala list"); 
       this.wildlifeListArrayReserve = this.wildlifeListArraySA.filter((wildlife)=>{
       return wildlife.notes_local === "Present";
      });
      
      });
       
     }

    fetchSpecies(binomial){
      //We are not using angularfireoffline here. MAY RECONSIDER
      this.wildlifeListToEdit = this.afDbase.list('/wildlife', {
      query: {
        orderByChild: 'binomial',
        equalTo: binomial 
        } 
      });
      }
    //NOT USED AT THE MOMENT
    updateSpecies(key,noteslocal,notesgeneral): void {
      this.wildlifeListToEdit.update(key, {notes_local:noteslocal, notes_general: notesgeneral}); 
      console.log("this update worked");         
    }

  
}
  


// WEBPACK FOOTER //
// ./src/providers/wildlife-service.ts